export default "__VITE_ASSET__B247r3ED__"